import { Moment } from 'moment';
import { ChartDataRow } from 'app/buffer-graph/models/chart-data-row';
import { ItemInfo } from 'app/buffer-graph/models/item-info';

export class ChartData {
    constructor(
        public readonly itemInfo: ItemInfo,
        public readonly rows: ChartDataRow[],
        public readonly min: number,
        public readonly max: number,
        public readonly rtMin: number,
        public readonly rtMax: number,
        public readonly startDate: Moment,
        public readonly endDate: Moment,
        public readonly visibleDaysCount: number,
        public readonly maxDaysCount: number,
        public readonly showAction: boolean,
        public readonly showSeason: boolean,
        public readonly showVacation: boolean,
        public readonly showHoliday: boolean,
        public readonly showOrderDay: boolean,
        public readonly showDeliveryDay: boolean,
        public readonly showBufferGrowFixed: boolean,
        public readonly showBufferDecreaseFixed: boolean,
        public readonly isMaxQuantityDisplayable: boolean,
        public readonly isMaxBufferDisplayable: boolean,
        public readonly showActionPriceItem: boolean,
        public readonly todayDate: Moment
    ) {

    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/chart-data.ts